<template>
  <div>
    <transition name="toasts">
      <div v-if="alertSuccessMsg != ''" class="alert alert-success toast">
        {{ alertSuccessMsg }}
      </div>
      <div v-if="alertErrorMsg != ''" class="alert alert-danger toast">
        {{ alertErrorMsg }}
      </div>
    </transition>
    <div class="blue-subhead-bg text-uppercase">
      <h1>Editing {{ program.name }}</h1>
    </div>
    <div class="container-fluid">
      <div class="edit-wrapper row-eq-height row">
        <edit-sidebar class="col-sm-3"></edit-sidebar>
        <div class="col-sm-9">
          <div class="content-wrapper">
            <br>
            <component
              :is="currentComponent"
              class="content-shared col-md-12"></component>
            <button
              v-if="!!programId && displaySaveButton.includes(currentComponent)"
              @click="save"
              class="btn btn-lg btn-default admin-btn-primary save col-md-2">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import EditSidebar from '../../components/admin/editLoyaltyProgram/EditSidebar'
import GeneralContent from '../../components/admin/editLoyaltyProgram/GeneralContent'
import RegistrationContent from '../../components/admin/editLoyaltyProgram/RegistrationContent'
import RebateContent from '../../components/admin/editLoyaltyProgram/RebateContent'
import RewardContent from '../../components/admin/editLoyaltyProgram/RewardContent'
import TrainingContent from '../../components/admin/editLoyaltyProgram/TrainingContent'

export default {
  name: 'EditLoyaltyProgramDetails',
  created () {
    this.$bus.on('swapComponent', this.swapComponent)
  },
  beforeDestroy () {
    this.$bus.off('swapComponent', this.swapComponent)
  },
  components: {
    'edit-sidebar': EditSidebar,
    'general-content': GeneralContent,
    'registration-content': RegistrationContent,
    'rebate-content': RebateContent,
    'reward-content': RewardContent,
    'training-content': TrainingContent
  },
  data () {
    return {
      alertSuccessMsg: '',
      alertErrorMsg: '',
      currentComponent: 'general-content',
      displaySaveButton: ['general-content', 'rebate-content', 'registration-content']
    }
  },
  computed: {
    ...mapGetters('loyaltyProgram', [ 'programId' ]),
    ...mapState('loyaltyProgram', ['program']),
    title () {
      return this.currentComponent.split('-')[0].toUpperCase()
    }
  },
  methods: {
    ...mapActions('loyaltyProgram', [ 'saveProgram' ]),
    swapComponent (component) {
      this.currentComponent = component.component
    },
    save () {
      this.saveProgram()
        .then(response => {
          this.alertSuccessMsg = 'Successfully saved!'
          setTimeout(() => {
            this.alertSuccessMsg = ''
          }, 1500)
        })
        .catch(err => {
          console.log(err)
          this.alertErrorMsg = 'Failed to save!'
          setTimeout(() => {
            this.alertErrorMsg = ''
          }, 1500)
          // console.log(err)
        })
    }
  }
}
</script>

<style scoped>
.toasts-enter,
.toasts-leave-to {
  opacity: 0;
  /* transform: scale(0.9); */
}

.toasts-enter-active, .toasts-leave-active {
  transition: opacity .8s;
}

.toast {
  position: fixed;
  top: 50px;
  right: 50px;
  z-index: 1;
}

.container-fluid {
  padding-left: 0;
}

.content-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 15px;
}

.content-shared {
  margin-bottom: 15px;
}

.save {
  align-self: flex-end;
  margin-top: auto;
}

.row-eq-height {
  min-height: 70vh;
}

</style>
